<template>
  <div class="nav-common">
    <div class="nav-bar">
      <div class="nav-top">
        <router-link to="/">首页</router-link>
        <router-link to="/About">关于我们</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Navcom",
  data() {
    return {

    }
  },
  created() {},
  methods: {},
  components: {}
};
</script>
<style lang="stylus" scoped>
.nav-bar {
  position: relative;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #123e97;
  overflow: hidden;

  &:before {
    position: absolute;
    display: block;
    content: '';
    border-top: 50px solid #fff;
    border-left: 50px solid transparent;
    border-right: 50px solid transparent;
    height: 0;
    width: 900px;
    left: 50%;
    margin-left: -500px;
    top: 5px;
  }

  .nav-top {
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    margin-top: 5px;

    a {
      display: inline-block;
      font-size: 16px;
      color: #333333;
      margin: 0 10px;
    }

    .router-link-exact-active {
      color: #123e97;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navtop/navloginbefore.vue